import { render } from "./GalleryPage.vue?vue&type=template&id=76fb183c&ts=true"
import script from "./GalleryPage.vue?vue&type=script&lang=ts"
export * from "./GalleryPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__